export default __webpack_public_path__ + "07ca334a26326e60aa8673fc907c9bca.png";